export const PRICING_PLAN_APP_DEF_ID = '1522827f-c56c-a5c9-2ac9-00f9e6ae12d3';

export const FEDOPS_SINGLE_SERVICE_WIDGET_EDITOR =
  'bookings-single-service-widget-editor';

export const SENTRY_BOOKINGS_WIDGET_DSN =
  'https://845cb258aed1430298e63a52da06351a@sentry.wixpress.com/178';
